export function attachPopoverEvents(element: Element, instance: any, _this: any) {
  if (!_this.shadowRoot) return;

  _this.addTrackedEventListener(document, 'click', (event) => {
    if (event instanceof CustomEvent) {
      return;
    }

    const popover = instance?.tip;
    const isOpen = !!(popover as HTMLElement)?.classList.contains('show');
    const path = event.composedPath();

    if (path.includes(element) || (popover && path.includes(popover))) {
      return;
    }

    if (isOpen) {
      popover.hide();
    }
  });

  _this.addTrackedEventListener(element, 'shown.bs.popover', () => _this.requestUpdate());
  _this.addTrackedEventListener(element, 'hidden.bs.popover', () => _this.requestUpdate());
}
